import React from "react";
import PropTypes from "prop-types";
import SendMessageButton from "./send_message_button";
import UserJobTitle from "./user_job_title";
import UserLinks from "./user_links";
import ProfileEdit from "./profile_edit";
import ProfileEditSf from "./profile_edit_sf";

function ProfilePage(props) {
  const { name, image, defaultUserImage } = props;
  const userImage = image ? image : defaultUserImage;

  return (
    <div id='object_cover' className='container-fluid'>
      <div className='row d-flex justify-content-center'>
        <div className='container'>
          <div className='row d-flex justify-content-center no-gutter'>
            <div id='object_unit' className='col-12 col-sm-10'>
              <table className='table'>
                <tbody>
                  <tr>
                    <td id='user_image' className='text-center'>
                      <img src={userImage} className='img-thumbnail rounded-circle' alt={name} />
                    </td>
                    <td id='object-info' className='d-none d-md-table-cell'>
                      <UserJobTitle {...props} />
                      <UserLinks {...props} />
                    </td>
                    <SendMessageButton {...props} />
                    <ProfileEdit {...props} />
                  </tr>
                  <tr className='d-md-none text-center'>
                    <td id='object-info'>
                      <UserJobTitle {...props} />
                      <UserLinks {...props} />
                      <ProfileEditSf {...props} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ProfilePage.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string,
  defaultUserImage: PropTypes.string.isRequired
};

ProfilePage.defaultProps = {
  image: null
};

export default ProfilePage;
